import API from '../http'

/**
 * 保存和修改字典
 * @param params
 * @returns
 */
export const Edit = (params: any) => {
  return API.POST('/admin/dict/save', params)
}

/**
 * 分页
 * @param params
 * @returns
 */
export const Page = (params: any) => {
  return API.POST('/admin/dict/page', params)
}

/**
 * 删除字典
 * @param params
 * @constructor
 */
export const Delete = (params: any) => {
  return API.POST('/admin/dict/delete', params)
}

/**
 * 字典详情
 * @param params
 * @constructor
 */
export const Detail = (params: any) => {
  return API.POST('/admin/dict/info', params)
}
